export default <{[key: string]: any}> [
    {
        items: [
            {
                label: 'API Subscriptions',
                icon: 'pi pi-arrow-right-arrow-left',
                route: '/api-subscriptions',
            },
            {
                label: 'Widget Subscriptions',
                icon: 'pi pi-code',
                route: '/widget-subscriptions',
            },
            // {
            //     label: 'Referrals',
            //     icon: 'pi pi-share-alt',
            //     route: '/referrals',
            //     // badge: 'Earn $100',
            // },
        ]
    },
]